var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Multiselect } from '../Multiselect/index.js';
import { FormControlLayout } from './FormControlLayout.js';
import { extractLayoutProps } from './utils.js';
export const FormControlMultiselect = (_a) => {
    var { onChange, placeholder, value = [], options } = _a, rest = __rest(_a, ["onChange", "placeholder", "value", "options"]);
    const { layoutProps, inputProps } = extractLayoutProps(rest);
    return (React.createElement(FormControlLayout, Object.assign({}, layoutProps),
        React.createElement(Multiselect, Object.assign({}, inputProps, { onChange: onChange, value: value || [], options: options }),
            React.createElement(Multiselect.Button, { placeholder: placeholder }, value === null || value === void 0 ? void 0 : value.map((item, index) => (React.createElement(Multiselect.SelectedItem, { key: index, value: item, index: index }, item)))),
            React.createElement(Multiselect.Items, null, options.map((item, index) => (React.createElement(Multiselect.Item, { key: index, value: item, index: index }, item)))))));
};
//# sourceMappingURL=FormControlMultiselect.js.map